import { useDispatch, useSelector } from 'react-redux';
import { taskBoardActions } from '../../../../store/slices/taskBoardSlice/taskBoardSlice';
import { useEffect, useState } from 'react';
import { deleteSearchParams } from '../../../../shared/helpers';
import { Task } from '../../../../entities/task/model/types/tasks';
import { useAppSelector } from '../../../../store';

export const useModalEditTask = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const { modalMode } = useSelector((store) => store.taskBoardReducer);
    const [previewEnable, setPreviewEnable] = useState(false);
    const pickedTaskUid = new URLSearchParams(window.location.search).get('task_id');
    const taskData: Task = useAppSelector((state) => state.tasksReducer.entities[pickedTaskUid]);
    const tasksInformationData = useAppSelector((state) => state.tasksInformationReducer);
    const editModalData = useAppSelector((state) => state.editModalReducer);
    const { isModalLoading, isModalError } = useAppSelector((state) => state.tasksReducer);
    const isObserver = taskData?.context?.highest_role === 'observer';

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                if (previewEnable) return;
                onHideModal();
            }
            return;
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [previewEnable]);

    const onHideModal = () => {
        deleteSearchParams('task_id');
        dispatch(taskBoardActions.onModalMode(null));
    };
    return {
        modalMode,
        taskData,
        editModalData,
        isModalLoading,
        isModalError,
        isObserver,
        pickedTaskUid,
        tasksInformationData,
        previewEnable,
        setPreviewEnable,
        onHideModal,
    };
};
